import { useCookies } from "@vueuse/integrations/useCookies"

import { ConsentMap, CookieCategory } from "./types"

const COOKIE_NAME = "myaccount_consent"
class CookieConsentServiceClass {
  protected getStoredConsent(): ConsentMap | null {
    return useCookies().get<ConsentMap>(COOKIE_NAME) ?? null
  }

  protected storeConsent(consent: ConsentMap): void {
    useCookies().set(COOKIE_NAME, consent, { path: "/" })
  }

  hasConsent(category: CookieCategory): boolean {
    if (window.Cookiebot?.consent) {
      return !!window.Cookiebot.consent[category]
    } else {
      const stored = this.getStoredConsent()
      return stored?.[category] ?? false
    }
  }

  runOnceCookieCategoryAccepted(
    category: CookieCategory,
    callback: () => void,
  ) {
    if (this.hasConsent(category)) {
      callback()
      return
    }

    const listener = () => {
      if (this.hasConsent(category)) {
        callback()
      }
    }

    window.addEventListener("CookiebotOnAccept", listener, false)
    window.addEventListener("CookiebotOnDecline", listener, false)
  }

  openPreferencesModal() {
    window.Cookiebot?.renew()
  }

  init() {
    const persistConsent = () => {
      const consent = window.Cookiebot?.consent
      if (consent) {
        this.storeConsent(consent)
      }
    }

    window.addEventListener("CookiebotOnAccept", persistConsent, false)
    window.addEventListener("CookiebotOnConsentReady", persistConsent, false)
    window.addEventListener("CookiebotOnDecline", persistConsent, false)
  }
}

export const CookieConsentService = new CookieConsentServiceClass()
